export enum DeliveryAuditGeo {
    APPROVED = 1,
    DISAPPROVED = 2,
}
